import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface PageComponentEntityParams {
  component?: string;
  location?: string;
  ui_event_context?: string;
  direct?: boolean;
  service?: string;
  data?: object;
}
export class PageComponentEntity extends BaseEntityClass {
  component?: string;
  location?: string;
  ui_event_context?: string;
  direct?: boolean;
  service?: string;
  data?: object;
  constructor(params: PageComponentEntityParams) {
    super();
    this.type = "page_component";
    this.entity_version = 2;
    this.component = params.component;
    this.location = params.location;
    this.ui_event_context = params.ui_event_context;
    this.direct = params.direct;
    this.service = params.service;
    this.data = params.data;
  }
}
